import DrawTool from '../draw/DrawTool'
import GeomTool from '../geom/GeomTool';
import MathTool from '../math/MathTool';
import ObjectTool from '../object/ObjectTool';
import TextureTool from '../texture/TextureTool';

export class Arc{
    constructor( x, y, outerRadius, innerRadius, start, end, gradient, layerId){
        this.x = x;
        this.y = y;
        this.outerRadius = outerRadius;
        this.innerRadius = innerRadius;
        this.start = start;
        this.end = end;
        this.gradient = gradient;
        this.layerId = layerId;

        // Geometry
        let ctx = window.p5App.drawingContext;
        ctx.beginPath();
        ctx.arc(x, y, outerRadius*.5, this.start, this.end);
        ctx.arc(x, y, innerRadius*.5, this.end, this.start, true);
        ctx.closePath();

        // Graphics
        p5App.push();
        ctx.fillStyle = this.gradient;
        ctx.fill();
        p5App.pop();
    }
}

/* 
    Example how to use: 
    let shape = new shapes.Stripes( options.margin, options.margin, pieceWidth-options.margin*2, 100, 20, 10, '#222222', 0 );    

    Draws a list of stripes (repetition of rect)
*/

export class Stripes{
    /**
     * 
     * @param {*} x 
     * @param {*} y 
     * @param {*} stripeWidth 
     * @param {*} stripeHeight 
     * @param {*} gap 
     * @param {*} numStripes 
     * @param {*} color 
     * @param {*} layerId 
     */
    constructor( x, y, stripeWidth, stripeHeight, gap, numStripes, color, layerId){
        this.x = x;
        this.y = y;
        this.stripeWidth = stripeWidth;
        this.stripeHeight = stripeHeight;
        this.gap = gap;
        this.numStripes = numStripes;
        this.color = color;
        this.layerId = layerId;


        let ctx = window.p5App.drawingContext;

        p5App.fill(this.color);
        for (let i = 0; i < this.numStripes; i++) {
            p5App.rect( 
                this.x, 
                this.y+i*(this.stripeHeight+this.gap), 
                this.stripeWidth, 
                this.stripeHeight 
            );    
        }
    }
}




export class Polygon{
    constructor( points, layerId, materials, baseColor ){
        this.points = points;
        this.layerId = layerId;
        this.baseColor = baseColor;
        this.materials = [];
        if( materials ){
            this.addMaterials(materials);
        }

        this.debugOutline = true;

        this.paint();
    }

    addMaterials( newMaterials ){
        for (let i = 0; i < newMaterials.length; i++) {
            const newMaterial = newMaterials[i];
            this.materials.push( newMaterial );
        }
    }
    
    // Returns the rectangle (x,y,width,height) enclosing the painted shape
    get boundingBox(){
        const xPostiions = ObjectTool.getPropertyOfObjectsArray( this.points, 'x' );
        const yPostiions = ObjectTool.getPropertyOfObjectsArray( this.points, 'y' );
        let minX = Math.min(...xPostiions);
        let minY = Math.min(...yPostiions);
        let maxX = Math.max(...xPostiions);
        let maxY = Math.max(...yPostiions);
        let box = {
            x: minX, 
            y: minY, 
            width: maxX-minX, 
            height: maxY-minY, 
        }
        return box;
    }

    paint(){
        //console.log( 'paint', this );
        // Geometry
        let projectedPoints = JSON.parse( JSON.stringify( this.points ) );
        let offset = 50;
        /* projectedPoints.forEach(point => {
            point.x -= window.mouseX*this.layerId*offset ; //gn.math.randInt(5,-5)
            point.y -= window.mouseY*this.layerId*offset ; //gn.math.randInt(5,-5)
            //console.log( "--- ", window.mouseX, this.layerId, offset );
        }); */
        const bb = this.boundingBox;

        // Graphics
        let ctx = p5App.drawingContext;
        
        //console.log( "Materials: ", this.materials)
        for (let i = 0; i < this.materials.length; i++) {
            const material = this.materials[i];
            if( material.type == "linearGradientFill" ){                
                 // Geometry
                ctx.beginPath();
                ctx.moveTo(projectedPoints[0].x, projectedPoints[0].y);
                projectedPoints.forEach(element => {
                    ctx.lineTo(element.x, element.y);                    
                });
                ctx.lineTo(projectedPoints[0].x, projectedPoints[0].y);
                ctx.closePath();

                // Graphics
                p5App.push();
                ctx.fillStyle = material.value;
                ctx.fill();
                p5App.pop();
            }
            else if( material.type == "plainColorFill" ){
                p5App.push();                          
                
                
                //ctx.filter = 'blur(100px)';
                p5App.fill(material.value);
                DrawTool.drawTriangle( projectedPoints );    
                p5App.pop();
                
            }
            else if( material.type == "plainColorStroke" ){
                //
                p5App.push();                    
                p5App.noFill();   
                let region = new Path2D();
                region.moveTo( this.points[0].x, this.points[0].y );
                for (let i = 0; i < this.points.length; i++) {
                    const point = this.points[i];
                    region.lineTo( point.x, point.y );                    
                }
                region.lineTo( this.points[0].x, this.points[0].y );   
                ctx.clip(region, "evenodd");  
                //ctx.lineCap = material.cap;
                p5App.strokeJoin(material.join);
                p5App.strokeCap(material.cap);
                p5App.strokeWeight( material.weight );
                p5App.stroke(material.color);
                //p5App.line( poly[0].x, poly[0].y, poly[1].x, poly[1].y );
                DrawTool.drawTriangle( projectedPoints );  
                p5App.pop();
                //
                /* p5App.push();                          
                p5App.noFill();                          
                p5App.stroke(material.value);
                p5App.strokeWeight(material.weight);
                p5App.strokeJoin(material.join);
                p5App.strokeCap(material.cap);
                DrawTool.drawTriangle( projectedPoints );    
                p5App.pop(); */
                
            }
            else if( material.type == "spaghetti" ){
                //console.log( "spaghetti material" );
                p5App.push();    
                //p5App.noFill();      
                //p5App.fill( MathTool.randomElementFromArray( material.value ) );
                //DrawTool.drawTriangle( projectedPoints );    
                //window.app.tick();
                //let sampledPoints = GeomTool.getRandomPointsInTriangle( projectedPoints, 10000);
                let sampledPoints = GeomTool.getRandomPointsWithinTriangle( projectedPoints, 10);
                //window.app.tick("ptsTraingle");
                DrawTool.drawSpeghetti(sampledPoints, sampledPoints.length*.5, 100, material.colors);
                p5App.pop();
                
            }
            else if( material.type == "sprinkle" ){
                //console.log( "sprinkle material" );
                p5App.push();          
                //p5App.fill( MathTool.randomElementFromArray( material.value ) );
                //DrawTool.drawTriangle( projectedPoints );    
                //window.app.tick();
                //let sampledPoints = GeomTool.getRandomPointsInTriangle( projectedPoints, 10000);
                let sampledPoints = GeomTool.getRandomPointsWithinTriangle( projectedPoints, material.numPoints);
                //window.app.tick("ptsTraingle");
                DrawTool.drawSprinkle(sampledPoints, material.colors, material.minRadius, material.maxRadius);
                p5App.pop();
                
            }
            else if( material.type == "glyph" ){
                //console.log( "ruin material" );
                p5App.push();          
                //p5App.fill( MathTool.randomElementFromArray( material.value ) );
                //DrawTool.drawTriangle( projectedPoints );    
                //window.app.tick();
                //let sampledPoints = GeomTool.getRandomPointsInTriangle( projectedPoints, 10000);
                let sampledPoints = GeomTool.getRandomPointsWithinTriangle( projectedPoints, material.numPoints);
                //window.app.tick("ptsTraingle");
                material.paint(sampledPoints, material.colors, material.minRadius, material.maxRadius);
                p5App.pop();
                
            }
            else if( material.type == "offset" ){
                //console.log( "ruin material" );
                p5App.push();    
                let bb = this.boundingBox 
                let grid = GeomTool.generateGridObject( bb.x, bb.y, bb.x+bb.width, bb.y+bb.height, bb.width/material.gap, bb.height/material.gap );
                let allPoints = grid.vertices.map( (v) => { return v.point; } );
                //console.log( 'grid allPoints:', allPoints.length );
                let inPoints = allPoints;
                /* let inPoints = allPoints.filter( (p) => { 
                    return GeomTool.pointInPolygon( projectedPoints, p ); 
                } ); */
                let radiuses = inPoints.map( (p) => { 
                    let posY = gn.math.map( p.y, bb.y, bb.y+bb.height, 0, 1 );
                    return material.radius*posY; 
                } );
                //p5App.drawingContext.save(); // Remove the clippping mask and go back to normal.
                p5App.noStroke();
                p5App.noFill();
                p5App.fill("#00ff0000");
                DrawTool.drawPointsArrayAsShape( projectedPoints, 0, 0);
                p5App.drawingContext.clip();
                p5App.fill(material.color);
                //DrawTool.drawPointsArrayAsCircles( inPoints, 0, 0, radiuses, material.color );
                inPoints.forEach( (p,i) => {
                    let r = radiuses[i];
                    window.p5App.circle( p.x, p.y, r )
                } );
                //p5App.drawingContext.restore(); // Remove the clippping mask and go back to normal.
                p5App.pop();
                
            }
            
        }
        
        /* if( this.debugOutline ){
            p5App.push();
            p5App.strokeWeight(5);
            let clr = '#00ff00';
            console.log( "clr: ", clr )
            p5App.stroke(clr );   
            p5App.pop();     
        } */
        //ctx.fillStyle = this.fillStyle;
        
        
        //p5App.pop();
        //console.log(this.points);

        /* p5App.push();
        let region = new Path2D();
        region.moveTo( projectedPoints[0].x, projectedPoints[0].y);
        projectedPoints.forEach(element => {
            region.lineTo( element.x, element.y);            
        });
        region.lineTo( projectedPoints[0].x, projectedPoints[0].y); 
        p5App.fill('#0000ff');
        //region.rect(100, 800, 1000, 300);
        
        ctx.clip(region, "evenodd"); */
        
        
        //TextureTool.generateScratchyoNoise( 0, 0, 3000, 3000, 1, 1, 100 )
        let area = bb.width*bb.height;
        /* TextureTool.generateStuccoNoise( bb.x, bb.y, bb.width, bb.height, 4, 1, area*0.01 )
        p5App.pop(); */
        
       /*  p5App.push();
        
        //ctx.save();
        p5App.stroke('#ff0000');
        p5App.noFill();
        p5App.rect( bb.x, bb.y, bb.width, bb.height)
        p5App.pop(); */
        //ctx.restore(); 

        /* if( gn.math.random() >0.5 ){
            p5App.push();
            p5App.strokeWeight( 1);
            //p5App.strokeWeight( 1, gn.math.randInt(10,1) );
            p5App.stroke('#ffffff70');
            console.log( "fillStyle: ", this.fillStyle )
            ctx.setLineDash([gn.math.randInt(5,10), gn.math.randInt(5,10)]);
            p5App.line( this.points[0].x, this.points[0].y, this.points[1].x, this.points[1].y)
            //p5App.rect( this.points[0].x, this.points[0].y, 100, 100)
            p5App.pop();
        } */
    }
}

export class Triangle extends Polygon{
}